import { render, staticRenderFns } from "./bindAcctWay.vue?vue&type=template&id=eb4aab1c"
import script from "./bindAcctWay.vue?vue&type=script&lang=js"
export * from "./bindAcctWay.vue?vue&type=script&lang=js"
import style0 from "./bindAcctWay.vue?vue&type=style&index=0&id=eb4aab1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports